export const popoverPositionsBottom = (config) => {
    const { arrowOffset, arrowSize } = config;
    const panelOffset = (arrowSize !== null && arrowSize !== void 0 ? arrowSize : 0) / 2;
    return [
        // bottom center
        {
            overlayX: 'center',
            overlayY: 'top',
            originX: 'center',
            originY: 'bottom',
            panelClass: ['top', 'center'],
            offsetY: panelOffset,
        },
        // bottom left
        {
            overlayX: 'start',
            overlayY: 'top',
            originX: 'center',
            originY: 'bottom',
            panelClass: ['top', 'left'],
            offsetX: -1 * (arrowOffset !== null && arrowOffset !== void 0 ? arrowOffset : 1),
            offsetY: panelOffset,
        },
        // bottom right
        {
            overlayX: 'end',
            overlayY: 'top',
            originX: 'center',
            originY: 'bottom',
            panelClass: ['top', 'right'],
            offsetX: arrowOffset,
            offsetY: panelOffset,
        },
    ];
};
